import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import navDate from "../plugin/nav";
import urlData from "../utils/urlData";
import store from "../store/index";
import { navHide, isWeiXin } from "../utils/index.js";
import lockr from "lockr";

import sdk from '../utils/wechart' //引入sdk.js


import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Router);
const router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
});


router.beforeEach((to, from, next) => {
  // console.log(from)
  store.commit("isNavShow", navHide(navDate, to.name));
  // console.log(isWeiXin(), 'true为微信，false为不是')

  // console.log(navHide(urlData, to.name), '是否是可忽略路由')
  if(to.path == '/wechart-qrcode'){
    next();
    return;
  } else if (!lockr.get('openId') && to.path != '/author') {
    // 第一次进入项目
    lockr.set('beforeLoginUrl', JSON.stringify(to)) // 保存用户进入的url
    next({
      path: '/author',
      query: to.query,
      params: to.params
    });
  } else if (to.path == "/author") {
    if(lockr.get('openId')){
      next({
        path: "index"
      });
    }else{
      next();
    }
  } else {

    if (lockr.get('openId')) {
      if (navHide(urlData, to.name) == true) {
        // if (to.name != 'login' && to.name != 'zdyx-clause') {
        //   lockr.set("oldUrl", to);
        // }
        next();
      } else {
        //   if(!store.getters.token || !getToken() ){
        if (!to.meta.keepAlive) {
          lockr.set("oldUrl", to);
        }
        // console.log(to)
        //     next({
        //       path: '/login',
        //       query: to.query,
        //       params: to.params
        //     });

        //    }else{
        next();
        //    }
      }
      lockr.set('beforeLoginUrl', '') // 保存用户进入的url
    } else {
      lockr.set('beforeLoginUrl', JSON.stringify(to)) // 保存用户进入的url
      next({
        path: "/author",
        query: to.query,
        params: to.params
      });
    }
  }
});

// router.afterEach((to, from, next) => {
//     // 设置标题
//     global.document.title = to.meta.title || '百分百生活馆'

//     // 滚动条回到头部
//     global.scrollTo(0, 0)
//   })


router.afterEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
 

  // global.scrollTo(0, 0)
  let menuList = [
    // "menuItem:share:timeline", //朋友圈
    // "menuItem:share:appMessage", //发送给朋友
    "menuItem:share:qq", //分享到QQ
    "menuItem:share:weiboApp", // 分享到Weibo
    "menuItem:favorite", // 收藏
    "menuItem:share:QZone", // 分享到 QQ 空间
    "menuItem:copyUrl", // 复制链接
    "menuItem:openWithQQBrowser", // 在QQ浏览器中打开
    "menuItem:openWithSafari", // 在Safari中打开
    "menuItem:share:email", // 邮件
    "menuItem:readMode", // 阅读模式
    "menuItem:originPage" // 原网页
  ];
  var url = window.location.href.split('#')[0]
  var obj = {
    title: "百分百生活馆",		//分享标题 
    desc: "精选好物 只在百分百",						//分享内容
    linkurl: location.protocol + "//" + location.host + '/html/#/index?invite_code=' + lockr.get("referral_code"),
    img: 'http://weizhui.xzbfb.com/html/share_icon.png',				//分享内容显示的图片
  }
  sdk.getJSSDK(url, obj, menuList)


});

export default router;
